export default "<app-network></app-network>\n";